import { render } from "./OnDuty.vue?vue&type=template&id=0a42797a&scoped=true"
import script from "./OnDuty.vue?vue&type=script&lang=js"
export * from "./OnDuty.vue?vue&type=script&lang=js"

import "./OnDuty.vue?vue&type=style&index=0&id=0a42797a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a42797a"]])

export default __exports__